import React from 'react';
import { Trophy, Target, Calendar, TrendingUp } from 'lucide-react';

const Progress = ({ progress, className = "" }) => {
  const { streakDays, totalWordsLearned, setsCompleted, accuracy } = progress;

  const stats = [
    {
      icon: Trophy,
      value: streakDays,
      label: "Days Streak",
      color: "text-yellow-500",
      bgColor: "bg-yellow-50"
    },
    {
      icon: Target,
      value: totalWordsLearned,
      label: "Words Learned",
      color: "text-blue-500",
      bgColor: "bg-blue-50"
    },
    {
      icon: Calendar,
      value: setsCompleted,
      label: "Sets Completed",
      color: "text-green-500",
      bgColor: "bg-green-50"
    },
    {
      icon: TrendingUp,
      value: `${accuracy}%`,
      label: "Accuracy",
      color: "text-purple-500",
      bgColor: "bg-purple-50"
    }
  ];

  return (
    <div className={`bg-white rounded-xl p-4 shadow-sm ${className}`}>
      <div className="grid grid-cols-2 gap-4">
        {stats.map((stat, index) => (
          <div key={index} className="text-center">
            <div className={`inline-flex items-center justify-center w-12 h-12 rounded-full ${stat.bgColor} mb-2`}>
              <stat.icon className={`w-6 h-6 ${stat.color}`} />
            </div>
            <div className="text-lg font-bold text-gray-800 mb-1">
              {stat.value}
            </div>
            <p className="text-xs text-gray-600">
              {stat.label}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Progress;
